'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = OnlinepbxSwitch;

var _onlinepbxQuestion = require('./onlinepbx-question');

var _onlinepbxQuestion2 = _interopRequireDefault(_onlinepbxQuestion);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function OnlinepbxSwitch(_ref) {
  var labelRight = _ref.labelRight,
      labelLeft = _ref.labelLeft,
      help = _ref.help,
      questionText = _ref.questionText,
      checked = _ref.checked,
      onClickChecked = _ref.onClickChecked,
      disabled = _ref.disabled;

  return _react2['default'].createElement(
    'div',
    {
      draggable: true,
      onDragStart: function () {
        function onDragStart(evt) {
          evt.stopPropagation();
          evt.preventDefault();
        }

        return onDragStart;
      }(),
      className: 'onlinepbx__lib__switch' },
    labelLeft && _react2['default'].createElement(
      'div',
      {
        onClick: onClickChecked,
        className: (0, _classnames2['default'])('onlinepbx__lib__switch__label', {
          'onlinepbx__lib__switch__label__active': labelLeft && labelRight && !checked || !(labelLeft && labelRight) && checked
        }) },
      labelLeft
    ),
    _react2['default'].createElement(
      'div',
      null,
      _react2['default'].createElement('input', {
        className: 'onlinepbx__lib__switch__input',
        type: 'checkbox',
        readOnly: true,
        checked: checked,
        disabled: disabled
      }),
      _react2['default'].createElement(
        'button',
        {
          onClick: onClickChecked,
          className: (0, _classnames2['default'])('onlinepbx__lib__switch__fantom', {
            'onlinepbx__lib__switch__fantom__active__color': checked && !(labelLeft && labelRight),
            'onlinepbx__lib__switch__fantom__active__position': checked && labelLeft && labelRight
          }),
          disabled: disabled
        },
        _react2['default'].createElement('div', { className: 'onlinepbx__lib__switch__fantom__toggle' })
      )
    ),
    labelRight && _react2['default'].createElement(
      'div',
      {
        onClick: onClickChecked,
        className: (0, _classnames2['default'])('onlinepbx__lib__switch__label', {
          'onlinepbx__lib__switch__label__active': checked
        }) },
      labelRight
    ),
    questionText && _react2['default'].createElement(_onlinepbxQuestion2['default'], {
      text: questionText
    })
  );
}